import './assets/shared.css';const a = "_surface_tgjac_16", c = "_backdrop_tgjac_21", o = "_overlay_tgjac_25", _ = "_dialog_tgjac_48", r = {
  surface: a,
  backdrop: c,
  overlay: o,
  dialog: _
};
export {
  r as s
};
